import { MgSupplierItemSearchResult } from '@retail/products/types';
import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { TrashIcon } from '@sanity/icons';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props {
  items: MgSupplierItemSearchResult[];
  removeCheckedItem: (id: number) => void;
}

export function MgSupplierItemsTableWithDelete({ items, removeCheckedItem }: Props) {
  const t = useProductsTFunction();

  return (
    <Table size="small">
      <TableHead>
        <TableRow sx={{ borderBottom: '2px solid', borderColor: 'grey.A100' }}>
          <TableCell>{t('products.mgItem.supplierItem.primaryText')}</TableCell>
          <TableCell>{t('products.supplier.name')}</TableCell>
          <TableCell>{t('products.mgItem.supplierItem.finfoNumber.label')}</TableCell>
          <TableCell>{t('products.mgItem.number.short')}</TableCell>
          <TableCell>{t('products.mgItem.supplierItem.bk04ProductCategory')}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {items.map((item, index) => {
          const { primaryText, finfoNumber, participantAccountName, mgItemNumber, bk04Varegruppe } =
            item;
          return (
            <TableRow
              key={finfoNumber}
              sx={{
                borderBottom: '1.5px solid',
                borderColor: 'grey.A100',
                backgroundColor: index % 2 === 0 ? 'grey.A100' : undefined,
              }}
            >
              <TableCell>
                <Typography variant="body1">{primaryText}</Typography>
              </TableCell>
              <TableCell>{participantAccountName}</TableCell>
              <TableCell>{finfoNumber}</TableCell>
              <TableCell>{mgItemNumber}</TableCell>
              <TableCell>{bk04Varegruppe?.getLabel()}</TableCell>
              <TableCell>
                <IconButton onClick={() => removeCheckedItem(item.mgItemNumber)}>
                  <TrashIcon fontSize="25px" />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
